module.exports = __webpack_public_path__ + "static/media/retail.86dee557.svg";